export default __webpack_public_path__ + "static/media/lightning.ac3e2044.svg";